import HeroSection from './HeroSection/HeroSection';
import React, { useState } from 'react';
import SvgMap from '../common/SvgMap';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as homeActions from '../home/redux/actions';

// const agenciesArr = [
//   {
//     locationName: 'Buin',
//     directionValue: 'BALMACEDA Nª 402',
//     agentValue: 'RODRIGO EDUARDO TAMAYO FLORES',
//     telePhoneValue: '123456789',
//   },
//   {
//     locationName: 'ESTACIÓN CENTRAL - TERM. BORJA OF. 42',
//     directionValue: 'SAN BORJA Nº 122, E. CENTRAL',
//     telePhoneValue: '123456789',
//     agentValue: 'HERNAN FERNANDO LOPEZ SOLIS',
//   },
//   {
//     locationName: 'ESTACIÓN CENTRAL - TERMINAL SUR OF 151',
//     directionValue: 'BALMACEDA Nª 402',
//     agentValue: 'RODRIGO EDUARDO TAMAYO FLORES',
//   },
//   {
//     locationName: 'Buin',
//     directionValue: 'BALMACEDA Nª 402',
//     telePhoneValue: '123456789',
//     agentValue: 'RODRIGO EDUARDO TAMAYO FLORES',
//   },
//   {
//     locationName: 'Buin',
//     directionValue: 'BALMACEDA Nª 402',
//     agentValue: 'RODRIGO EDUARDO TAMAYO FLORES',
//   },
//   {
//     locationName: 'ESTACIÓN CENTRAL - TERM. BORJA OF. 42',
//     directionValue: 'SAN BORJA Nº 122, E. CENTRAL',
//     telePhoneValue: '123456789',
//     agentValue: 'HERNAN FERNANDO LOPEZ SOLIS',
//   },
//   {
//     locationName: 'Buin',
//     directionValue: 'BALMACEDA Nª 402',
//     agentValue: 'RODRIGO EDUARDO TAMAYO FLORES',
//     telePhoneValue: '123456789',
//   },
//   {
//     locationName: 'ESTACIÓN CENTRAL - TERM. BORJA OF. 42',
//     directionValue: 'SAN BORJA Nº 122, E. CENTRAL',
//     telePhoneValue: '123456789',
//     agentValue: 'HERNAN FERNANDO LOPEZ SOLIS',
//   },
//   {
//     locationName: 'ESTACIÓN CENTRAL - TERMINAL SUR OF 151',
//     directionValue: 'BALMACEDA Nª 402',
//     agentValue: 'RODRIGO EDUARDO TAMAYO FLORES',
//   },
//   {
//     locationName: 'Buin',
//     directionValue: 'BALMACEDA Nª 402',
//     telePhoneValue: '123456789',
//     agentValue: 'RODRIGO EDUARDO TAMAYO FLORES',
//   },
//   {
//     locationName: 'Buin',
//     directionValue: 'BALMACEDA Nª 402',
//     agentValue: 'RODRIGO EDUARDO TAMAYO FLORES',
//   },
//   {
//     locationName: 'ESTACIÓN CENTRAL - TERM. BORJA OF. 42',
//     directionValue: 'SAN BORJA Nº 122, E. CENTRAL',
//     telePhoneValue: '123456789',
//     agentValue: 'HERNAN FERNANDO LOPEZ SOLIS',
//   },
// ];

function Agencies({ t, actions }) {
  const [agenciesArr, setAgenciesArr] = useState([]);
  const [loading, setLoading] = useState(false);
  return (
    <React.Fragment>
      <div style={{ marginTop: '65px' }}>
        <HeroSection
          title="Agencias"
          description="Home / Agencias"
          height="40vh"
          heroImage="/images/agencies/agencies-banner.jpg"
        />
      </div>
      <div className="content-container">
        <div className="pullman-section-primary-row">
          <div className="pullman-section-primary-row-main-heading black-text margin-T30">
            {t('AGENCIES.FIND_YOUR_NEAREST_AGENCY')}
          </div>
          <div className="pullman-section-primary-row-underline margin-B35"></div>
        </div>
        <div className="agencies-card">
          <div className="agencies-left">
            <SvgMap
              setAgenciesArr={setAgenciesArr}
              setLoading={setLoading}
              apiCall={actions.apiCall}
            />
          </div>
          <div className="agencies-right ">
            <div className="agencies-list scrollbar-y ">
              {!loading ? (
                agenciesArr.length !== 0 ? (
                  agenciesArr.map(item => (
                    <div className="agencies-item">
                      <div className="agencies-location-name black-text font9">
                        <img src="/images/agencies/agencies-location-pin.svg" alt="" />
                        <span>{item.agency_name}</span>
                      </div>
                      <div className="agencies-direction">
                        <span className="agencies-direction-label">{t('AGENCIES.DIRECTION')}</span>
                        &nbsp;:
                        <span className="agencies-direction-value">{item.address}</span>
                      </div>
                      {item.telephone && (
                        <div className="agencies-telephone">
                          <span className="agencies-telephone-label">
                            {t('AGENCIES.TELEPHONE')}
                          </span>
                          &nbsp;:
                          <span className="agencies-telephone-value">{item.telephone}</span>
                        </div>
                      )}
                      <div className="agencies-agent">
                        <span className="agencies-agent-label">{t('AGENCIES.AGENT')}</span>&nbsp;:
                        <span className="agencies-agent-value">{item.agent_name}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="d-flex mx-auto my-auto">
                    {t('AGENCIES.THERE_ARE_NO_AGENCIES_AVAILABLE_FOR_THIS_REGION')}
                  </div>
                )
              ) : (
                <div className="d-flex mx-auto my-auto">{t('CHANGE_TICKET.LOADING')}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
    pbPaymentDetails: state.pbPaymentDetails,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(Agencies));



// WEBPACK FOOTER //
// ./src/features/pages/Agencies.js